import { render, staticRenderFns } from "./TranslateTool.vue?vue&type=template&id=6b72f8a6&scoped=true"
import script from "./TranslateTool.vue?vue&type=script&lang=js"
export * from "./TranslateTool.vue?vue&type=script&lang=js"
import style0 from "./TranslateTool.vue?vue&type=style&index=0&id=6b72f8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72f8a6",
  null
  
)

export default component.exports